module.exports = __webpack_public_path__ + "static/media/IE1@2x.ffd6e716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/IE/IE1@2x.png
// module id = 653
// module chunks = 0